exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js!normalize.css/normalize.css"), "");
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js!./scaffolding.css"), "");
// Module
exports.push([module.id, "/* stylelint-disable */\r\n\r\n/* stylelint-enable */", ""]);
